<template lang="pug">
v-layout(column)
  v-card.mt-4.elevation-0
    website-table(v-model='websites', :loading='loading')

</template>

<script>
export default {
  name: 'WebsitesOverview',

  components: {
    WebsiteTable: require('../WebsiteTable').default
  },

  data () {
    return {
      websites: []
    }
  },

  async created () {
    this.loading = true

    this.websites = await this.$store.dispatch('graphqlQuery', {
      name: 'getBusinessLeaseWebsites',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    })

    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
</style>
